import * as actions from 'pkg/actions';
import * as endpoints from 'pkg/api/endpoints/auto';
import type * as models from 'pkg/api/models';
import { withSdk } from 'pkg/core/with_sdk';
import { crash } from 'pkg/errors/errors';

interface UpdatePayload {
	name?: string;
	language?: string;
	groups?: number[];
}

export async function update(site: models.site.Site, payload: UpdatePayload) {
	const updatedSite = await withSdk<models.site.Site>(
		'patch',
		endpoints.Sites.Update(site.groupId, site.id)
	)(payload);

	if (!updatedSite) {
		const c = crash();

		actions.flashes.show({
			title: c.title,
			message: c.description,
		});
	}

	return updatedSite;
}
